<!--
    描述：投递名片
    日期：2022/7/25
    创建人：李家宝
-->
<template>
  <div>
    <p>
      当前投递名片人数：<span style="color: #0000FF">{{
        this.tableData.length
      }}</span>
    </p>
    <el-table
    
      class="mt20"
      :data="tableData"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column type="index" label="序号" align="center" width="70">
      </el-table-column>
      <el-table-column prop="providerName" label="投递名片人" width="180"  show-overflow-tooltip >
      </el-table-column>
      <el-table-column prop="linkPhone" label="投递人联系方式" align="center">
      </el-table-column>
      <el-table-column prop="applyType" label="投递人类型" align="center">
        <template slot-scope="scope">
          {{
            scope.row.applyType == 0
              ? "个人"
              : "企业"
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="provinceAndCityName"
        label="所属地区"
           width="250"
        align="center"  show-overflow-tooltip 
      ></el-table-column>
      <el-table-column
        prop="applyTime"
        label="投递时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="applyNums"
        label="投递岗位数量"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column prop="applyPositions" label="投递工种"    show-overflow-tooltip  >
        <template slot-scope="scope">
          <span v-for="(item,index) in scope.row.applyPositions" :key="item.id ">
            {{ item.positionName }} <span v-if="index < (scope.row.applyPositions.length-1)">|</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="applyStatus" label="招募方意见" align="center">
        <template slot-scope="scope">
          {{
            scope.row.applyStatus == 0
              ? "待定"
              : scope.row.applyStatus == 1
              ? "可面试"
              : "不合适"
          }}
        </template>
      </el-table-column>
    </el-table>
    <div class="w-table-footer" v-if="tableData.length > 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="pageList"
        :page-size="size"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getProviderApplyList } from "api/modules/projectManagement";

export default {
  name: "deliver-card",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      tableData: [],  // 列表数据
      page: 1, // 页数
      size: 10, // 条数
      pageList: [10, 20, 50, 100], // 每页显示多少条
      total: 0 // 总条数
    };
  },
  methods: {
    // 获取数据
    getData() {
      getProviderApplyList({
        recruitId: this.rowData.businessId,
        current: this.page,
        size: this.size
      }).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },

    // 切换显示条数
    handleSizeChange(val) {
      this.size = val;
      this.getData();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    }
  },

  created() {},

  mounted() {
    this.getData();
  }
};
</script>

<style scoped>
.w-table-footer {
  display: flex;
  justify-content: center;
  margin: 20px;
}
</style>
